var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chip',{staticClass:"vehicle-type-chip",style:(_vm.vehicleTypeColor),attrs:{"small":"","text-color":_vm.textColor}},[_c('strong',[_vm._v(_vm._s(_vm.$t(_vm.vehicleType)))])])}
var staticRenderFns = []

export { render, staticRenderFns }